export default {
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
};
